module.exports = __webpack_public_path__ + "static/media/stamp_14.8e3400f0.png";